import { render, staticRenderFns } from "./marketDataReport.vue?vue&type=template&id=0f88ec4a&scoped=true&"
import script from "./marketDataReport.vue?vue&type=script&lang=js&"
export * from "./marketDataReport.vue?vue&type=script&lang=js&"
import style0 from "./marketDataReport.vue?vue&type=style&index=0&id=0f88ec4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88ec4a",
  null
  
)

export default component.exports